import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/shared/components/Component";
import Page from "src/shared/components/Page";
import withAppContext from "src/shared/components/withAppContext";
import withAxios from "src/shared/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import {
  LOGO_1_INPUT_LABEL,
  // LOGO_2_INPUT_LABEL,
  PRIMARY_COLOR_INPUT_LABEL,
  SECONDARY_COLOR_INPUT_LABEL,
  SLUG_INPUT_LABEL,
  SLUG_INPUT_PLACEHOLDER,
  TAGLINE_INPUT_LABEL,
  TAGLINE_INPUT_PLACEHOLDER,
  // UNSAVED_CHANGES_PROMPT,
  UPDATE,
} from "./constants";
import { styles } from "./styles";
import { IDirectorSettingsState, IProps } from "./types";
import { Button, LinearProgress } from "@material-ui/core";
import PartialCleanCheck from "src/shared/components/PartialCleanCheck";
import { APP_LOGO_BASE64 } from "src/constants";
// import { Prompt } from "react-router-dom";
export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(
        class extends Component<IProps, IDirectorSettingsState> {
          public partialCleanCheck: PartialCleanCheck<IDirectorSettingsState> =
            new PartialCleanCheck(this, [
              "name",
              "primaryColor",
              "secondaryColor",
              "slug",
              "tagline",
              "imageChanged",
              "mascot"
            ]);

          public readonly state = this.buildState({
            name: '',
            loadedSlug: "",
            logo1: APP_LOGO_BASE64,
            logo2: APP_LOGO_BASE64,
            primaryColor: "#494b8f",
            secondaryColor: "#ffffff",
            slug: "",
            tagline: "",
            loading: false,
            school: this.props.school,
            imageChanged: false,
            schools: [],
            postingSchool: undefined,
            submitting: undefined,
            mascot:""
          });
          public readonly handlePrimaryChange = this.stateInputEventHandler(
            (v) => ({ primaryColor: v })
          );
          public readonly handleSecondaryChange = this.stateInputEventHandler(
            (v) => ({ secondaryColor: v })
          );
          // public readonly handleLogo1Change = this.handleImageUploadAsync(
          //   (result: any) => ({
          //     imageChanged: true,
          //     logo1: result,
          //   })
          // );
                      
          // public readonly handleLogo2Change = this.handleImageUploadAsync(
          //   (result) => ({
          //     imageChanged: true,
          //     logo2: result,
          //   })
          // );
          public handleNameChange = this.stateInputEventHandler(
            (v) => ({ name: v })
          );
          public handleMascotChange = this.stateInputEventHandler(
            (v) => ({ mascot: v })
          );
          private readonly handleTaglineChange = this.stateInputEventHandler(
            (v) => ({ tagline: v })
          );

          private readonly handleSlugChange = this.stateInputEventHandler(
            (v) => ({ slug: v.replace(/\s/, "") })
          );
          public canSubmit = () => {
            const {
              submitting,
              name,
              slug,
              primaryColor,
              secondaryColor,
            } = this.state;
            return (
              Boolean(name) &&
              Boolean(slug) &&
              submitting === undefined &&
              this.uniqueSlug() &&
              this.validHexColor(primaryColor) &&
              this.validHexColor(secondaryColor)
            );
          };

          public uniqueSlug = () => {
            const { slug, school } = this.state;
            return (
              this.state.schools.find(
                (s: any) =>
                  s.slug.toLowerCase() === slug.toLowerCase() &&
                  (school === undefined ? true : school.id !== s.id)
              ) === undefined
            );
          };

          public componentDidMount() {
            this.getAllSlug()
            this.props.loadDirectors();
            if (this.state?.school?.name) {
              this.setState({ name: this.state.school?.name })
            }
            if (this.state?.school?.tagline) {
              this.setState({ tagline: this.state.school?.tagline })
            }
            if (this.state?.school?.mascot) {
              this.setState({ mascot: this.state.school?.mascot })
            }
            if (this.state?.school?.slug) {
              this.setState({ slug: this.state.school?.slug })
            }
            if (this.state?.school?.logo1!=="") {
              this.setState({ logo1: this.state.school?.logo1 })
            }
            if (this.state?.school?.logo2!=="") {
              this.setState({ logo2: this.state.school?.logo2 })
            }
            // this.handlePrimaryChange
            if (this.state?.school?.primaryColor!=="") {
              this.setState({ primaryColor: this.state.school?.primaryColor })
            }
            if (this.state?.school?.secondaryColor!=="") {
              this.setState({ secondaryColor: this.state.school?.secondaryColor })
            }

          }
 public readonly handleLogo1Change = async (event: React.ChangeEvent<HTMLInputElement>) => {
            const file = event.target.files?.[0];
          
            // VALIDATION
            if (!file) {return;}
          
            // Only image files allowed
            if (!file.type.startsWith("image/")) {
              alert("Please upload an image file only.");
              event.target.value = "";
              return;
            }
          
            //  Max 2MB size limit
            const MAX_SIZE_MB = 5;
            const MAX_BYTES = MAX_SIZE_MB * 1024 * 1024;
          
            if (file.size > MAX_BYTES) {
              alert(`Image too large! Maximum allowed size is ${MAX_SIZE_MB} MB.`);
              event.target.value = "";
              return;
            }
          
            //  SAME OLD LOGIC (do not change this)
            const originalHandler = this.handleImageUploadAsync((result) => ({
              imageChanged: true,
              logo1: result,
            }));
          
            return originalHandler(event);
          };
          public async getAllSlug() {
            const AllSchoolSlug: any = await this.buildGet(
              this,
              `school/getAllSchoolSlug`
            )();
            if (AllSchoolSlug?.data?.length > 0) {
              this.setState({ schools: AllSchoolSlug?.data })
            }
          }
          public handleImageUploadAsync<K extends keyof IDirectorSettingsState>(
            formatResult: (result: string) => Pick<IDirectorSettingsState, K>
          ) {
            return this.stateInputEventHandlerAsync(async (elem) => {
              const result = await new Promise<string | void>(
                (resolve, reject) => {
                  if (!elem.files) {
                    throw new Error("Element is not a file selection element.");
                  } else if (!elem.files[0]) {
                    resolve();
                  } else {
                    const reader = new FileReader();
                    reader.onerror = () => {
                      reject(reader.error);
                    };
                    reader.onload = () => {
                      if (typeof reader.result === "string") {
                        resolve(reader.result);
                      } else {
                        resolve();
                      }
                    };
                    reader.readAsDataURL(elem.files[0]);
                  }
                }
              );
              return result ? formatResult(result) : undefined;
            });
          }
          public validHexColor(color: string) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
          }
          public updateSchool: () => void = () =>
            void this.runCancellableStatefulAsync(
              this,
              {
                postingSchool: true,
                submitting: true,
              },
              {
                postingSchool: undefined,
                submitting: undefined,
              },
              async () => {
                console.log("updateSchool==========>")
                const {
                  name,
                  primaryColor,
                  secondaryColor,
                  slug,
                  tagline,
                  logo1,
                  logo2,
                  mascot
                } = this.state;
                const response: any = await this.buildPut(
                  this,
                  `school/updateSchool/${this.state.school?.id}`
                )({
                  logo1,
                  logo2,
                  name: name?.trim(),
                  primaryColor,
                  secondaryColor,
                  slug: slug?.trim(),
                  tagline: tagline?.trim(),
                  mascot
                });
                if (response?.status) {
                  this.setState({ school: response?.data })
                  this.props.loadSchool()
                }
                console.log("response===========>", response)
              },
              () => {
                this.setState({ submitting: undefined, postingSchool: undefined, });
              }
            );

          public render() {
            const {
              appContext: { user, baseUri },
              classes
            } = this.props;
            console.log(user)
            const {
              loading,
              logo1,
              // logo2,
              primaryColor,
              secondaryColor,
              name,
              tagline,
              slug,
              loadedSlug,
              mascot,
              // postingSchool,
              submitting
            } = this.state;
            return (
              <Page
                header={'Manage School'}
                subtitle={''}
              >
                {/* <Prompt
                  when={
                    !this.partialCleanCheck.isClean() &&
                    postingSchool === undefined
                  }
                  message={UNSAVED_CHANGES_PROMPT}
                /> */}
                {submitting && <LinearProgress />}

                {/* <form className={classes.formdev}>
                <div className={classes.updatebtn}>
                <Button
                  onClick={this.updateSchool}
                  style={{ marginTop: 10 }}
                  variant="contained"
                  color="primary"
                  disabled={!this.canSubmit() || this.partialCleanCheck.isClean()}
                >
                  {UPDATE}
                </Button>
                </div>
                  <label className={classes.labelcolor}>
                    Name: <input value={name} onChange={this.handleNameChange} />
                  </label>
                  <br />
                  <label>
                    {TAGLINE_INPUT_LABEL}
                    <input
                      placeholder={TAGLINE_INPUT_PLACEHOLDER}
                      value={tagline}
                      onChange={this.handleTaglineChange}
                    />
                  </label>
                  <br />
                  <label>
                    {SLUG_INPUT_LABEL}
                    <input
                      placeholder={SLUG_INPUT_PLACEHOLDER}
                      value={slug}
                      onChange={this.handleSlugChange}
                    />
                    <span style={{ color: "red" }}>
                      {slug === "" || this.uniqueSlug() ? "" : " Unavailable"}
                    </span>
                  </label>
                  <br />
                  <label>
                    <img id="target" src={logo1} className={classes.image} />
                    <br />
                    {LOGO_1_INPUT_LABEL}
                    <input
                      id="logo1"
                      name="logo1"
                      type="file"
                      onChange={this.handleLogo1Change}
                      accept="image/*"
                    />
                  </label>
                  <br />
                  <label>
                    <img id="target" src={logo2} className={classes.image} />
                    <br />
                    {LOGO_2_INPUT_LABEL}
                    <input
                      id="logo2"
                      name="logo2"
                      type="file"
                      onChange={this.handleLogo2Change}
                      accept="image/*"
                    />
                  </label>
                  <br />
                  <label>
                    {PRIMARY_COLOR_INPUT_LABEL}
                    <input
                      placeholder={primaryColor}
                      value={primaryColor}
                      onChange={this.handlePrimaryChange}
                    />
                    <input
                      type="color"
                      name="primaryColor"
                      value={
                        this.validHexColor(this.state.primaryColor)
                          ? this.state.primaryColor
                          : "#ffffff"
                      }
                      onChange={this.handlePrimaryChange}
                    />
                  </label>
                  <br />
                  <label>
                    {SECONDARY_COLOR_INPUT_LABEL}
                    <input
                      placeholder={secondaryColor}
                      value={secondaryColor}
                      onChange={this.handleSecondaryChange}
                    />
                    <input
                      type="color"
                      name="secondaryColor"
                      value={
                        this.validHexColor(this.state.secondaryColor)
                          ? this.state.secondaryColor
                          : "#ffffff"
                      }
                      onChange={this.handleSecondaryChange}
                    />
                  </label>
                </form> */}
                <form className={classes.formdev}>
                  <div className={classes.updatebtn}>
                    <div className={classes.spanlink}>
                      {loadedSlug === "" ? null : (
                        <span>
                          School Link:{" "}
                          <a target="_blank" href={`${baseUri}/${loadedSlug}`}>
                            /{loadedSlug}
                          </a>
                        </span>
                      )}
                    </div>
                    <div>
                      {loading && <LinearProgress />}
                      <Button


                        onClick={this.updateSchool}
                        style={{ marginTop: "10", backgroundColor: "#494b8f", color: "#ffffff" }}
                        variant="contained"
                        color="primary"
                        disabled={!this.canSubmit() || this.partialCleanCheck.isClean()}
                      >
                        {UPDATE}
                      </Button>
                    </div>
                  </div>
                  <div className={classes.allnameflex}>
                    <div className={classes.labelflex}>
                      <label className={classes.labelcolor}>
                        Name:
                      </label>
                      <br />
                      <input value={name} onChange={this.handleNameChange} className={classes.inputboxis} />
                    </div>
                    <div className={classes.labelflex}>
                      <label className={classes.labelcolor}>
                        {TAGLINE_INPUT_LABEL}
                      </label>
                      <br />
                      <input
                        className={classes.inputboxis}
                        placeholder={TAGLINE_INPUT_PLACEHOLDER}
                        value={tagline}
                        onChange={this.handleTaglineChange}
                      
                      />
                    </div>
                  </div>
                  <div className="slug-mascot">
                  <div className="slug-innder">
                    <label className={classes.labelcolor}>
                      {SLUG_INPUT_LABEL}

                      <span className={classes.unavailable}>
                        {slug === "" || this.uniqueSlug() ? "" : " Unavailable"}
                      </span>
                    </label>
                    <br />
                    <input
                      className={classes.inputboxis1}
                      placeholder={SLUG_INPUT_PLACEHOLDER}
                      value={slug}
                      onChange={this.handleSlugChange}
                      disabled={true}
                    />
                  </div>
                 
                  <div className={classes.labelflex}>
                      <label className={classes.labelcolor}>
                        Mascot:
                      </label>
                      <br />
                      <input value={mascot} onChange={this.handleMascotChange} className={classes.inputboxis} placeholder="Mascot"/>
                    </div>
                    </div>
                  <div className={classes.allnameflex1}>
                    <div className={classes.logo1divs}>
                      <label className={classes.logo1lable}>
                        <img id="target" src={logo1} className={classes.image} />
                      </label>
                      <br />
                     <h4 style={{ fontSize: "15px" }}>{LOGO_1_INPUT_LABEL}</h4>
                      <input
                        className={classes.inputlogo1}
                        id="logo1"
                        name="logo1"
                        type="file"
                        onChange={this.handleLogo1Change}
                        accept="image/*"
                        style={{ position: "relative", right: "60px" }}
                      />
                    </div>
                    {/* <div className={classes.logo1divs}>
                      {logo2 === "" ? null : <label className={classes.logo1lable}>
                        <img id="target" src={logo2} className={classes.image} />
                      </label>}
                      <br />
                      <h4 style={{ fontSize: "15px" }}>{LOGO_2_INPUT_LABEL}</h4>

                      <input
                        className={classes.inputlogo1}
                        id="logo2"
                        name="logo2"
                        type="file"
                        onChange={this.handleLogo2Change}
                        accept="image/*"
                        style={{ position: "relative", right: "60px" }}
                        disabled={true}
                      />
                    </div> */}
                  </div>
                  <div className={classes.primarysec}>
                    <div className={classes.primary}>
                      <label className={classes.labelcolor}>
                        {PRIMARY_COLOR_INPUT_LABEL}

                      </label>
                      <br />
                      <input
                        className={classes.primaryinputcolor}
                        placeholder={primaryColor}
                        value={primaryColor}
                        onChange={this.handlePrimaryChange}
                      />
                      <input
                        className={classes.colorprimary}
                        style={{ position: "relative", top: "8px" }}
                        type="color"
                        name="primaryColor"
                        value={
                          this.validHexColor(this.state.primaryColor)
                            ? this.state.primaryColor
                            : "#ffffff"
                        }
                        onChange={this.handlePrimaryChange}
                      />
                    </div>
                    <div className={classes.secondary}>
                      <label className={classes.labelcolor}>
                        {SECONDARY_COLOR_INPUT_LABEL}

                      </label>
                      <br />
                      <input
                        className={classes.primaryinputcolor}
                        placeholder={secondaryColor}
                        value={secondaryColor}
                        onChange={this.handleSecondaryChange}
                      />
                      <input
                        className={classes.colorprimary}
                        style={{ position: "relative", top: "8px" }}
                        type="color"
                        name="secondaryColor"
                        value={
                          this.validHexColor(this.state.secondaryColor)
                            ? this.state.secondaryColor
                            : "#ffffff"
                        }
                        onChange={this.handleSecondaryChange}
                      />
                    </div>
                  </div>

                </form>
              </Page>
            );
          }


        }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/editSchoolUser/index.tsx